import { useTranslation } from "react-i18next";
import { useI18nNavigate } from "@/hooks/use-i18n-navigate";
import { ActivateSection } from "./activate-section";
import { WaitlistButton } from "./waitlist-section";

export const Invite = () => {
  const { t } = useTranslation();
  const navigate = useI18nNavigate();
  return (
    <div className="min-h-screen flex">
      <div className="w-full bg-[rgba(9,0,20,1)]">
        <div className="flex h-full flex-col items-center justify-center px-12">
          {/* Logo */}
          <a href="https://miuta.ai/" target="_blank">
            <div className="w-16 h-16 bg-i-primary rounded-full flex items-center justify-center mb-6">
              <span className="text-white text-4xl font-bold">M</span>
            </div>
          </a>

          {/* 登录表单 */}
          <div className="w-full max-w-sm">
            <h2 className="text-3xl font-bold mb-2 text-white text-center">
              {t("invite.index.activate_account")}
            </h2>
            <p
              className="leading-4 text-sm text-white text-center mb-6 opacity-80"
              dangerouslySetInnerHTML={{ __html: t("invite.index.welcome") }}
            ></p>

            <WaitlistButton />

            <div className="flex items-center w-full my-6">
              <div className="flex-1 h-px bg-gray-700" />
              <span className="mx-4 text-gray-500 text-sm">
                {t("invite.index.already_have_code")}
              </span>
              <div className="flex-1 h-px bg-gray-700" />
            </div>

            <ActivateSection />
          </div>

          <button
            className="absolute top-4 right-4 text-white/70 hover:text-white text-md font-medium hover:bg-white/5 px-3 py-2 rounded-md transition-all duration-200"
            onClick={() => navigate("/login/", { replace: true })}
          >
            ← {t("invite.index.back")}
          </button>
        </div>
      </div>
    </div>
  );
};
